import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Scrollbars } from "react-custom-scrollbars";
import Skeleton from "react-loading-skeleton";
import { connect } from "react-redux";
import { saveCart, saveCartJobs } from "../../../lib/cart";
import {
  setCartAddedAddons,
  setCartAddedPackages,
  setCartJobItems,
  setCartProducts,
  setCartStage,
} from "../../../redux/actions/cartAction";
import { setShowMobileIstand } from "redux/actions/cartAction";
import ProductAddonTourFlow from "../../common/ProductAddonTourFlow";
import AddonItem from "./addons/AddonItem";
import SelectedAddonItem from "./addons/SelectedAddonItem";
import EmptyCartModal from "./EmptyCartModal";
import { isMobile } from "react-device-detect";
import ViewOtherServices from "./ViewOtherServices";
import API from "api";
import toast from "react-hot-toast";
import { IoMdArrowRoundBack } from "react-icons/io";
import { gtm_ecommerce_remove_from_cart } from "lib/GA4_tag";
import { RepairInsuranceCheck } from "lib/data/constants";

const Cart = ({
  apiData,
  cart,
  setCartProducts,
  setCartJobItems,
  setCartAddedAddons,
  setCartAddedPackages,
  setShowMobileIstand,
  setCartStage,
  globalData,
  id,
}) => {
  let { stage, products, jobItems, addons, addedAddons, addedPackages } = cart;

  const [showEmpty, setShowEmpty] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [tyreProduct, setTyreProduct] = useState(null);
  const [freeOilChange, setFreeOilChange] = useState(null);
  const [discountValue, setDiscountValue] = useState(null);
  const router = useRouter();

  let header = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  const filteredValues = apiData?.variants;

  useEffect(() => {
    const obWorkshop = localStorage.getItem("obWorkshop");
    if ((addons?.length == 0 && obWorkshop) || cart.stage == 4) {
      setCartStage(4);
    }
  }, [addons]);
  useEffect(() => {
    const tyreProduct = JSON.parse(
      localStorage.getItem("tyreProduct") || JSON.stringify("")
    );
    if (tyreProduct) {
      setTyreProduct(tyreProduct);
    }
  }, [localStorage.getItem("tyreProduct"), products]);
  useEffect(() => {
    const freeOilChange = JSON.parse(
      localStorage.getItem("freeOilData") || JSON.stringify("")
    );
    if (freeOilChange) {
      setFreeOilChange(freeOilChange);
    }
  }, [localStorage.getItem("freeOilData")]);
  const isWorkshopCollection = sessionStorage.getItem("isWorkshopCollection");
  const handleViewMoreServices = () => {
    setShowModal(!showModal);
  };

  const handleCloseViewMore = () => {
    setShowModal(!showModal);
  };

  const calculateDiscount = (jobItem) => {
    const cost = jobItem.Cost;
    if (
      cart.appliedCartOffers &&
      ((cart.appliedCartOffers.PromotionType != "WorkshopProductPromotion" &&
        cart.appliedCartOffers.PromotionType != "WorkshopPromotion") ||
        ((cart.appliedCartOffers.PromotionType == "WorkshopProductPromotion" ||
          cart.appliedCartOffers.PromotionType == "WorkshopPromotion") &&
          cart.appliedCartOffers?.isOfferWorkshopSelected))
    ) {
      const isOfferAvailable =
        jobItem.Offers && jobItem?.Offers.length
          ? jobItem.Offers.filter(
              (offer) => offer.PromotionId == cart.appliedCartOffers.PromotionId
            ).length
          : false;
      if (!isOfferAvailable) {
        return 0;
      }
      const discountPercentage = cart?.appliedCartOffers?.PromotionPercentValue
        ? parseFloat(cart?.appliedCartOffers?.PromotionPercentValue)
        : 0;
      const d_amount = (parseFloat(cost) * discountPercentage) / 100;
      const flatvalue = parseFloat(
        cart?.appliedCartOffers?.PromotionFlatValue
          ? cart?.appliedCartOffers?.PromotionFlatValue
          : 0
      );
      const remainingValue = cost - d_amount - flatvalue;
      return parseFloat(remainingValue).toFixed(2);
    }
    return null;
  };

  useEffect(() => {
    if (cart.addons && cart.addons?.length && cart.jobItems?.length) {
      const filterAddons = cart?.addons?.filter((item) => item.IsFree);
      setCartAddedAddons(filterAddons);
    }
  }, [cart.addons]);

  useEffect(() => {
    if (cart.stage != null && cart.workshop != null && cart.jobItems) {
      // saveCart(cart, apiData, globalData);
    }
  }, [cart.workshop, cart.jobItems, cart.addedAddons]);

  const handleAddAddon = (addon) => {
    const result = addedAddons.filter((res) => res.id == index);
    if (result.length == 0) {
      setCartAddedAddons([...addedAddons, addon]);
    } else {
      alert("already added");
    }
  };
  const productNavigate = (variant) => {
    let immutableUrl = "/";
    router.query.slug?.map((item, index) => {
      immutableUrl += index == 1 ? variant.Slug : item;
      immutableUrl += "/";
      return item;
    });
    router.push(
      {
        pathname: `/services/[...slug]`,
      },
      "/services" + immutableUrl,
      { shallow: true }
    );
  };

  const switchService = async (variant) => {
    let removingItemId = 0;
    const remainProducts = products.filter((item, index) => {
      if (item.ExcludeVariants.length === 0) {
        return true;
      }
      if (item.ExcludeVariants[0].ExcludeJourneyVariantId === variant.Id) {
        removingItemId = item.Id;
      }
      return item.ExcludeVariants[0].ExcludeJourneyVariantId !== variant.Id;
    });
    const workshop = cart.workshop;
    const result = products.filter((res, index) => res.Id == variant.Id);
    if (result.length == 0) {
      try {
        const { data: res } = await API.get(
          `v2/api/workshops/${workshop?.Id}/jobs?page=1&variantId=${variant.Id}&carModelId=${globalData.carData?.modelId}&sortingCol=Distance&workshopId=${workshop?.Id}&lat=1&lng=1&size=40`,
          {
            headers: header,
          }
        );
        localStorage.setItem("service-selected", JSON.stringify(res.Data[0]));
        let jobs = jobItems.filter(
          (res, index) => res.JourneyVariantId !== removingItemId
        );
        setCartProducts([...remainProducts, variant]);
        setCartJobItems([...jobs, res.Data[0]]);
        saveCartJobs(cart, apiData, globalData, [...jobs, res.Data[0]]);
      } catch (error) {
        toast.dismiss();
        toast.error("Something went wrong! Please retry.");
      }
    } else {
      toast.dismiss();
      toast.error("Already Added!");
    }
  };

  const selectViewMore = async (variant) => {
    const result = products.filter((res, index) => res.Id == variant.Id);
    const workshop = cart.workshop;
    const defaultProduct = variant.Products[0] || null;
    if (result.length == 0) {
      try {
        const { data: res } = await API.get(
          `v2/api/workshops/${workshop?.Id}/jobs?page=1&variantId=${variant.Id}&carModelId=${globalData.carData?.modelId}&sortingCol=Distance&workshopId=${workshop?.Id}&lat=1&lng=1&size=40&brandId=${defaultProduct?.Id}`,
          {
            headers: header,
          }
        );
        localStorage.setItem(
          "service-selected",
          JSON.stringify({ ...res.Data[0], BrandId: defaultProduct?.Id })
        );
        setCartProducts([...products, variant]);
        setCartJobItems([
          ...jobItems,
          { ...res.Data[0], BrandId: defaultProduct?.Id },
        ]);
        saveCartJobs(cart, apiData, globalData, [
          ...jobItems,
          { ...res.Data[0], BrandId: defaultProduct?.Id },
        ]);
        productNavigate(variant);
      } catch (e) {
        toast.dismiss();
        toast.error("Something went wrong! Please retry.");
      }
    } else {
      toast.dismiss();
      toast.error("Already Added!");
    }
  };
  const closecart = () => {
    setShowMobileIstand(false);
  };

  const RemovePackageFromcartEvent = (item) => {
    const filterCategory = apiData.categories?.filter((item) => item.ID == 15);
    const event = {
      currency: "AED",
      value: item.Cost,
      items: [
        {
          item_id: item.Id,
          item_name: item.Name,
          // discount: variant.DiscountedCost || 0,
          item_category: filterCategory[0].Name,
          item_list_id: filterCategory[0].ID,
          item_list_name: filterCategory[0].Name,
          price: item.Cost,
          quantity: 1,
        },
      ],
    };

    gtm_ecommerce_remove_from_cart(event);
  };

  const RemoveFromCartEvent = (item) => {
    let offer;
    const isOfferApplied =
      cart.appliedCartOffers?.variantId == item?.JourneyVariantId;
    if (isOfferApplied) {
      offer = item.Offers.filter(
        (e) => e.PromotionId == cart.appliedCartOffers?.PromotionId
      );
    }
    // const filterCategory = globalData.currentCategory?.filter(
    //   (item) => item.ID == variant.JourneyCategoryId
    // );
    const event = {
      currency: "AED",
      value: item.Cost,
      items: [
        {
          item_id: item.JourneyVariantId,
          item_name: item.JourneyVariantName,
          coupon: offer?.length
            ? offer[0]?.PromotionCode || offer[0].PromotionId
            : null,
          // discount: variant.DiscountedCost || 0,
          // item_category: filterCategory[0].Name,
          // item_list_id: filterCategory[0].ID,
          // item_list_name: filterCategory[0].Name,
          price: item.Cost,
          quantity: 1,
        },
      ],
    };

    gtm_ecommerce_remove_from_cart(event);
  };

  const workshopURL =
    router.query.slug &&
    cart.workshop &&
    router.query.slug[3] == cart.workshop?.Slug;
  return (
    <div style={{ paddingBottom: "150px" }}>
      <EmptyCartModal
        id={id}
        show={showEmpty}
        onHide={() => {
          sessionStorage.removeItem("get-fitting-at-home");
          setShowEmpty(false)
        }}
        title="Are you sure?"
        message="By removing last item, your cart will be reset to empty cart."
      />
      <ViewOtherServices
        jobItems={jobItems}
        cart={cart}
        show={showModal}
        onHide={handleCloseViewMore}
        apiData={apiData}
        selectViewMore={selectViewMore}
        switchService={switchService}
      />

      {stage == 2 ? (
        <div className="px-2 job-list-area">
          <div>
            {addedPackages?.length > 0 ||
              (jobItems?.length > 0 && (
                <div className="island-header-bar">
                  <div className="d-flex justify-content-between align-items-baseline">
                    <h3>Selected Service(s)</h3>
                  </div>
                  <div
                    className="back-btn"
                    style={{ fontSize: 12 }}
                    onClick={() => {
                      if (isWorkshopCollection) {
                        setShowMobileIstand(false);
                        return;
                      }
                      setCartStage(cart.stage - 1);
                    }}
                  >
                    {isMobile ? (
                      <img src="/assets/BACK.png" width="25px"></img>
                    ) : (
                      <>
                        {!isWorkshopCollection ? (
                          <>
                            <img
                              src="/assets/BACK.png"
                              width="22px"
                              style={{ marginTop: "-2px" }}
                            ></img>
                            <span
                              style={{
                                textDecoration: "none",
                                color: "black",
                                marginRight: "10px",
                              }}
                            >
                              Back
                            </span>
                          </>
                        ) : null}
                      </>
                    )}
                  </div>
                </div>
              ))}
          </div>

          <div className="widget-service-island">
            <ul className="widget-service-island-ul">
              <div className="cst-scroll-sum ">
                {addedPackages != "" &&
                  addedPackages.map((e, index) => (
                    <li>
                      <small>
                        <img src={e.ImgUrl} />
                      </small>
                      <div className="island-sr-right">
                        <h3>
                          {e.Name}{" "}
                          <span className="badge cst-blck badge-secondary text-light">
                            {e.JourneyCategoryId === RepairInsuranceCheck
                              ? "Repair Insurance"
                              : "Service Contract"}
                          </span>
                        </h3>
                        <p>{e.ShortDescription}</p>
                        <span>AED {e.Cost}</span>
                        <i
                          className="fa-regular fa-circle-xmark"
                          onClick={() => {
                            const result = addedPackages.filter(
                              (res, index) => res.Id != e.Id
                            );
                            if (result.length == 0) {
                              setShowEmpty(true);
                              return;
                            }
                            RemovePackageFromcartEvent(e);
                            setCartAddedPackages(result);
                          }}
                        />
                      </div>
                    </li>
                  ))}
                {router.query.slug &&
                router.query.slug[1] == "tyre" &&
                tyreProduct?.length > 0
                  ? tyreProduct.map((e, index) => (
                      <li>
                        <small>
                          <img src={e.ImgUrl || "/assets/products/tire.webp"} />
                        </small>
                        <div className="island-sr-right">
                          <h3>{e.Name}</h3>
                          <p>
                            {e.ShortDescription}
                          </p>
                          <span>AED</span>
                          <span
                            className={
                              calculateDiscount(e) ? "offer-applied-ui" : ""
                            }
                          >
                            {e.CostBeforeOffer > 0 &&
                              e.CostBeforeOffer != e.Cost && (
                                <del
                                  className="mr-1"
                                  style={{ color: "#848484" }}
                                >
                                  {e.CostBeforeOffer}
                                </del>
                              )}{" "}
                            {e.Cost}
                          </span>
                          {calculateDiscount(e) ? (
                            <span className="ml-1">{calculateDiscount(e)}</span>
                          ) : null}

                          <i
                            className="fa-regular fa-circle-xmark"
                            onClick={() => {
                              const result = products.filter(
                                (res, index) => res.Id != e.Id
                              );
                              const resultJobItems = jobItems.filter(
                                (res) => res.Id != e.Id
                              );
                              if (result.length == 0) {
                                setShowEmpty(true);
                                return;
                              }
                              localStorage.setItem(
                                "tyreProduct",
                                JSON.stringify([...result])
                              );
                              RemoveFromCartEvent(e);
                              if (
                                result.length != 0 ||
                                (workshopURL && router.query.id !== "1")
                              ) {
                                setCartProducts(result);
                                setCartJobItems(resultJobItems);
                                // saveCart(cart, apiData, globalData);
                                saveCartJobs(
                                  cart,
                                  apiData,
                                  globalData,
                                  resultJobItems
                                );
                              } else {
                                setShowEmpty(true);
                              }
                            }}
                          />
                        </div>
                      </li>
                    ))
                  : jobItems &&
                    jobItems != "" &&
                    jobItems.length &&
                    jobItems.map((e, index) => (
                      <li>
                        <small>
                          <img src={e.JourneyVariantImageUrl} />
                        </small>
                        <div className="island-sr-right">
                          <h3>{e.JourneyVariantName || e.Name}</h3>
                          <p>
                            {e.ShortDescription}
                          </p>
                          <span>AED</span>
                          <span
                            className={
                              calculateDiscount(e) ? "offer-applied-ui" : ""
                            }
                          >
                            {e.CostBeforeOffer > 0 &&
                              e.CostBeforeOffer != e.Cost && (
                                <del
                                  className="mr-1"
                                  style={{ color: "#848484" }}
                                >
                                  {e.CostBeforeOffer}
                                </del>
                              )}{" "}
                            {freeOilChange &&
                            freeOilChange?.JourneyVariantId ==
                              e.JourneyVariantId ? (
                              <del
                                className="mr-1"
                                style={{ color: "#848484" }}
                              >
                                {e.Cost}
                              </del>
                            ) : null}
                            {freeOilChange &&
                            freeOilChange?.JourneyVariantId ==
                              e.JourneyVariantId
                              ? "Free"
                              : e.Cost}
                          </span>
                          {calculateDiscount(e) ? (
                            <span className="ml-1">{calculateDiscount(e)}</span>
                          ) : null}

                          <i
                            className="fa-regular fa-circle-xmark"
                            onClick={() => {
                              const result = products.filter(
                                (res, index) => res.Id != e.JourneyVariantId
                              );
                              const resultJobItems = jobItems.filter(
                                (res) =>
                                  res.JourneyVariantId != e.JourneyVariantId
                              );
                              if (result.length == 0) {
                                setShowEmpty(true);
                                return;
                              }
                              RemoveFromCartEvent(e);
                              if (
                                result.length != 0 ||
                                (workshopURL && router.query.id !== "1")
                              ) {
                                setCartProducts(result);
                                setCartJobItems(resultJobItems);
                                // saveCart(cart, apiData, globalData);
                                saveCartJobs(
                                  cart,
                                  apiData,
                                  globalData,
                                  resultJobItems
                                );
                              } else {
                                setShowEmpty(true);
                              }
                            }}
                          />
                        </div>
                      </li>
                    ))}

                {addedPackages.length === 0 &&
                  jobItems.length === 0 &&
                  (cart.showLoader ? (
                    <div className="details py-2 px-4 mt-3">
                      <h6 className="my-2">
                        <Skeleton count={1} />
                      </h6>
                      <p className=" my-1">
                        <Skeleton count={1} />
                      </p>
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <img src="/assets/images/cart.webp" width={"50%"} />
                      <div style={{ marginTop: "10%" }}>Select the service</div>
                    </div>
                  ))}
              </div>
            </ul>
          </div>
          {cart.workshop ? (
            <div className="other-garage-service text-center mt-2 show-section-mobile">
              <button
                className="srv-act-action"
                onClick={closecart}
                // onClick={() => handleViewMoreServices()}
                data-toggle="modal"
                data-target="#moregarageModal"
              >
                Add More Services From This Workshop?
              </button>
            </div>
          ) : null}
        </div>
      ) : stage == 4 ? (
        <div
          className="px-2 job-list-area dfddgdsd"
          style={{
            height:
              addedPackages.length === 0
                ? "calc(100vh - 332px)"
                : "calc(100vh - 400px)",
          }}
        >
          {/* {addedPackages?.length > 0 ||
            (jobItems?.length > 0 && (
              <div className="island-header-bar">
                <h3>Service(s) Selected</h3>
                <span onClick={() => setCartStage(1)}>Change Service</span>
              </div>
            ))} */}
          <div className="">
            {addedPackages?.length > 0 ||
              (jobItems?.length > 0 && (
                <div className="island-header-bar">
                  <h3>Selected Service(s)</h3>
                  <div style={{ display: "flex", alignItems: "baseline" }}>
                    <div
                      className="back-btn"
                      style={{ marginRight: "22px" }}
                      onClick={() => {
                        setCartStage(cart.stage - 1);
                      }}
                    >
                      {isMobile ? (
                        <img src="/assets/BACK.png" width="25px"></img>
                      ) : null}
                    </div>
                    <span
                      style={{ marginRight: "10px" }}
                      onClick={() => setCartStage(2)}
                    >
                      Change
                    </span>
                  </div>
                </div>
              ))}
            <div className="widget-service-island">
              <ul className="widget-service-island-ul">
                {/* <Scrollbars
                    style={{ height: "400px"}}
                  > */}
                <div className="cst-scroll-sum">
                  {router.query.slug &&
                  router.query.slug[1] == "tyre" &&
                  tyreProduct?.length > 0
                    ? tyreProduct.map((e, index) => (
                        <li>
                          <small>
                            <img
                              src={e.ImgUrl || "/assets/products/tire.webp"}
                            />
                          </small>
                          <div className="island-sr-right">
                            <h3>{e.Name}</h3>
                            <p>
                              {e.ShortDescription}
                            </p>
                            <span>AED</span>
                            <span
                              className={
                                calculateDiscount(e) ? "offer-applied-ui" : ""
                              }
                            >
                              {e.CostBeforeOffer > 0 &&
                                e.CostBeforeOffer != e.Cost && (
                                  <del
                                    className="mr-1"
                                    style={{ color: "#848484" }}
                                  >
                                    {e.CostBeforeOffer}
                                  </del>
                                )}{" "}
                              {e.Cost}
                            </span>
                            {calculateDiscount(e) ? (
                              <span className="ml-1">
                                {calculateDiscount(e)}
                              </span>
                            ) : null}

                            <i
                              className="fa-regular fa-circle-xmark"
                              onClick={() => {
                                const result = products.filter(
                                  (res, index) => res.Id != e.Id
                                );
                                const resultJobItems = jobItems.filter(
                                  (res) => res.Id != e.Id
                                );

                                if (result.length == 0) {
                                  setShowEmpty(true);
                                  return;
                                }
                                RemoveFromCartEvent(e);
                                if (result.length != 0) {
                                  localStorage.setItem(
                                    "tyreProduct",
                                    JSON.stringify([...result])
                                  );
                                  setCartProducts(result);
                                  setCartJobItems(resultJobItems);
                                  // saveCart(cart, apiData, globalData);
                                  saveCartJobs(
                                    cart,
                                    apiData,
                                    globalData,
                                    resultJobItems
                                  );
                                } else {
                                  setShowEmpty(true);
                                }
                              }}
                            />
                          </div>
                        </li>
                      ))
                    : jobItems != "" &&
                      jobItems.map((e, index) => (
                        <li>
                          <small>
                            <img src={e.JourneyVariantImageUrl} />
                          </small>

                          <div className="island-sr-right">
                            <h3>
                              {e.JourneyVariantName || e.Name}{" "}
                              <label
                                className="cmn-label"
                                style={{ display: "none" }}
                              >
                                Service Contract label
                              </label>
                            </h3>
                            <p>
                              {e.ShortDescription}
                            </p>
                            <span>AED</span>
                            <span
                              className={
                                calculateDiscount(e) ? "offer-applied-ui" : ""
                              }
                            >
                              {" "}
                              {e.CostBeforeOffer > 0 &&
                                e.CostBeforeOffer != e.Cost && (
                                  <del
                                    className="mr-1"
                                    style={{ color: "#848484" }}
                                  >
                                    {e.CostBeforeOffer}
                                  </del>
                                )}
                              {freeOilChange &&
                              freeOilChange?.JourneyVariantName ==
                                e.JourneyVariantName ? (
                                <del
                                  className="mr-1"
                                  style={{ color: "#848484" }}
                                >
                                  {e.Cost}
                                </del>
                              ) : null}
                              {freeOilChange &&
                              freeOilChange?.JourneyVariantName ==
                                e.JourneyVariantName
                                ? "Free"
                                : e.Cost}
                            </span>
                            {calculateDiscount(e) ? (
                              <span className="ml-1">
                                {calculateDiscount(e)}
                              </span>
                            ) : null}
                            <i
                              className="fa-regular fa-circle-xmark"
                              onClick={() => {
                                const result = products.filter(
                                  (res, index) => res.Id != e.JourneyVariantId
                                );
                                const resultJobItems = jobItems.filter(
                                  (res) =>
                                    res.JourneyVariantId != e.JourneyVariantId
                                );
                                if (result.length == 0) {
                                  setShowEmpty(true);
                                  return;
                                }
                                RemoveFromCartEvent(e);
                                if (
                                  result.length != 0 ||
                                  (workshopURL && router.query.id !== "1")
                                ) {
                                  setCartProducts(result);
                                  setCartJobItems(resultJobItems);
                                  // saveCart(cart, apiData, globalData);
                                  saveCartJobs(
                                    cart,
                                    apiData,
                                    globalData,
                                    resultJobItems
                                  );
                                } else {
                                  setShowEmpty(true);
                                }
                              }}
                            />
                          </div>
                        </li>
                      ))}
                  {addedPackages != "" &&
                    addedPackages.map((e, index) => (
                      <div
                        className="workshop-bar"
                        style={{ border: "none", paddingBottom: "0px" }}
                      >
                        <div
                          className="cart-list p-2 w-100"
                          style={{ border: "none" }}
                        >
                          <img
                            src={e.ImgUrl}
                            alt="ob-image"
                            width={80}
                            height={80}
                            className="logo"
                            style={{ borderRadius: "10px", objectFit: "cover" }}
                          />
                          <div className="w-100">
                            <div className="d-flex justify-content-between align-items-center w-100">
                              <div
                                className="ml-2 w-100 title"
                                style={{ fontSize: "16px", fontWeight: "700" }}
                              >
                                {e.Name}{" "}
                                <span className="badge cst-blck badge-secondary">
                                  {e.JourneyCategoryId === RepairInsuranceCheck
                                    ? "Repair Insurance"
                                    : "Service Contract"}
                                </span>
                              </div>
                            </div>
                            <div
                              className="description"
                              style={{
                                marginLeft: "2%",
                                width: "100%",
                                fontSize: "12px",
                              }}
                            >
                              {e.ShortDescription}
                            </div>
                            <div
                              className="cost"
                              style={{
                                marginLeft: "2%",
                                width: "100%",
                                fontSize: "14px",
                                fontWeight: "bold",
                                color: "#000",
                              }}
                            >
                              {/* {e.Cost > 0 && e.Cost != e.Cost && (
                        <del className="mr-1" style={{ color: "#848484" }}>
                          AED {e.Cost}
                        </del>
                      )} */}
                              {"AED " + e.Cost}
                            </div>
                          </div>
                          <i
                            className="fa-regular fa-circle-xmark"
                            onClick={() => {
                              RemovePackageFromcartEvent(e);
                              const result = addedPackages.filter(
                                (res, index) => res.Id != e.Id
                              );
                              if (result.length == 0) {
                                setShowEmpty(true);
                                return;
                              }
                              setCartAddedPackages(result);
                            }}
                          />
                        </div>
                      </div>
                    ))}
                  {cart.addedAddons.length > 0 && (
                    <>
                      <hr className="m-0" />
                      <div className="d-flex justify-content-between pt-2">
                        <p
                          className="m-0 px-2"
                          style={{ fontSize: 13, fontWeight: "600" }}
                        >
                          Selected Addon(s)
                        </p>
                        <a onClick={() => setCartStage(3)}>
                          <p
                            className="m-0 px-2 text-primary"
                            style={{ fontSize: 12 }}
                          >
                            <u>Change</u>
                          </p>
                        </a>
                      </div>

                      <div className=" ml-2 addonspace-element d-flex justify-content-end flex-column">
                        <Row>
                          {cart.addedAddons.map((e, index) => (
                            <Col md={6} className="px-1 mt-1">
                              <SelectedAddonItem addon={e} />
                            </Col>
                          ))}
                        </Row>
                      </div>
                    </>
                  )}
                </div>
              </ul>
            </div>
          </div>

          {cart.showLoader ? (
            <div className="details py-2 px-4">
              <h6 className="my-2 ">
                <Skeleton count={1} />
              </h6>
              <p className=" my-1">
                <Skeleton count={1} />
              </p>
              <p className=" my-1">
                <Skeleton count={1} />
              </p>
            </div>
          ) : null}

          {addedPackages.length === 0 && jobItems.length === 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img src="/assets/images/cart.webp" alt="cart" width={"50%"} />
              <div style={{ marginTop: "10%" }}>Select the service</div>
            </div>
          )}
        </div>
      ) : (
        <div className="mx-0 pb-1">
          {/* <div className="rounded" style={{ background: "rgb(132, 132, 132)" }}>
            <div className="text-white p-2">Add-Ons Services</div>
          </div> */}
          <div className="d-flex justify-content-between align-items-baseline">
            <div
              // style={{ textTransform: "uppercase" }}
              className="workshop-block-island-st-1"
            >
              <h2>CHOOSE ADD-ONs </h2>
            </div>
            <div
              className="back-btn"
              style={{ marginRight: "22px", fontSize: 12 }}
              onClick={() => {
                setCartStage(cart.stage - 1);
              }}
            >
              {isMobile ? (
                <img src="/assets/BACK.png" width="25px"></img>
              ) : (
                <>
                  <img
                    src="/assets/BACK.png"
                    width="22px"
                    style={{ marginTop: "-2px" }}
                  ></img>
                  <span style={{ textDecoration: "none", color: "black" }}>
                    Back
                  </span>
                </>
              )}
            </div>
          </div>

          {addons?.length === 0 && (
            <>
              <Row className="justify-content-center align-items-center p-3">
                We don't have any addons to show for the currently selected
                service!
              </Row>
            </>
          )}

          {addons == null && (
            <>
              <Skeleton count={3} style={{ height: "60px" }} />
            </>
          )}
          {addons != null && addons != undefined && addons != "" && (
            <>
              <div className="widget-addon-block">
                <div className="cst-scroll-sum">
                  {/* <ProductAddonTourFlow /> */}

                  <div className="">
                    <ul className="widget-addon-ul">
                      {addons.map((e, index) => (
                        <AddonItem addon={e} index={index} />
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    cart: state.cart,
    globalData: state.globalData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCartProducts: (products) => {
      dispatch(setCartProducts(products));
    },
    setCartJobItems: (jobs) => {
      dispatch(setCartJobItems(jobs));
    },
    setCartAddedAddons: (addons) => {
      dispatch(setCartAddedAddons(addons));
    },
    setCartAddedPackages: (packages) => {
      dispatch(setCartAddedPackages(packages));
    },
    setCartStage: (stage) => {
      dispatch(setCartStage(stage));
    },
    setShowMobileIstand: (value) => {
      dispatch(setShowMobileIstand(value));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Cart);
